<template>
  <div class="reunion-cartera-container">
    <v-container grid-list-xs pt-0>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="iframe-wrapper">
            <iframe
              src="https://agendavirtual.aseguradoradelsur.com/portal-embed#/4334477000008380482"
              width="100%"
              height="800px"
              frameborder="0"
              allowfullscreen
              style="border: none; border-radius: 4px;"
            ></iframe>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'ReunionCartera',
  data() {
    return {};
  },
  mounted() {
    console.log('Módulo Reunión con Cartera cargado');
  }
};
</script>

<style scoped>
.reunion-cartera-container {
  width: 100%;
  height: 100%;
}

.iframe-wrapper {
  width: 100%;
  margin-top: 20px;
}
</style>
